import { cn } from '@/utils'

export type TSeparatorProps = {
	/**
	 * Adds a top margin so that the separator would not affect the height of the container but would overlap the previous element.
	 * This is useful when designs require the separator to align to the bottom of the container so it doesn't affect the layout.
	 */
	collapse: boolean
	className?: string
}

export const Separator = ({ collapse, className }: TSeparatorProps) => (
	<div
		className={cn(
			'border-b border-border-grey-50',
			collapse && '-mt-px',
			className,
		)}
	/>
)
